import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
// import $ from 'jquery';

Component('tr-repository-folder-table-toolbar', {
  mixins: [eventListenerMixin],

  properties: {
    selected: {
      type: Array,
      default: [],
      observer: 'changeSelected',
    },
    active: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.count = this.querySelector('.count');
    this.delete = this.querySelector('.batch-delete');
    this.cancel = this.querySelector('.cancel-button');
    this.table = document.querySelector('tr-repository-folder-table tr-table');

    this.listenTo(this.cancel, 'click', () => {
      this.selected = [];
      this.table.unselectAllRows();
      this.table.refreshAllCheckbox();
    });
  },

  changeSelected() {
    this.active = this.selected.length > 0;
    this.count.innerText = this.selected.length;
    this.delete.dataset.params = `tr_repository_batch_destruction[resource_gids]=${this.selected.join(',')}`;
  },
});
